import { messagesActionTypes } from '@constants/actionTypes/commonActionTypes';
import defaultMessages from '@i18n/base/messages_en.json';

export const INITIAL_STATE = {
    loadedLanguages: [],
    ['en']: defaultMessages
};

export default (state = INITIAL_STATE, action = {}) => {
    switch(action.type) {
        case messagesActionTypes.SET_MESSAGES:
            return {
                ...state,
                [action.lang]: action.messages.default,
                
            };
        case messagesActionTypes.SET_LOADED_MESSAGES:
            return {
                ...state,
                loadedLanguages: action.loadedLanguages
            };
        default:
            return state;
    }
};